import React from 'react';
import './MainMenuHeader.scss'

const CustomMenuHeader = React.memo((props) => {

  return (
    <div className="menu-header">
      <nav className={`menu ${props.isMenuActive ? "active" : "inactive"}`} >
        <ul>
          <li>
            <a href={`${window._env_.REACT_APP_DASHBOARD || 'https://dashboardkbqa.iartest.com/'}`}>
              <span>Dashboard</span>
              <i className="icon-th screen-guide-icon" />
            </a>
          </li>
          <li>
            <a href={`${window._env_.REACT_APP_LEGACY_DASHBOARD || 'https://adminfunctions-qa.iartest.com'}`}>
              <span>Administrative functions</span>
              <i className="icon-users screen-guide-icon" />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
})

export default CustomMenuHeader
